import { Col, Row, Switch } from "antd";
import React, { useRef, useState, useEffect } from 'react';
import { DebateLftIcon, DebateNewLogo, DebateRgtIcon } from "utils/assets/images";
import SentryWrap from 'components/Sentry';

const SwiperCarousel = ({ children, ...swiperProps }) => {
    const [SwiperModule, setSwiperModule] = useState(null);

    useEffect(() => {
        import("swiper/react").then(module => {
            setSwiperModule(module);
        });
    }, []);

    if (!SwiperModule) {
        return <div style={{ textAlign: 'center', padding: '20px' }}>Loading carousel...</div>;
    }

    const { Swiper, SwiperSlide } = SwiperModule;
    
    const processedChildren = React.Children.map(children, (child, index) => {
        if (React.isValidElement(child) && child.props && child.props['data-swiper-slide']) {
            return <SwiperSlide key={child.key || index}>{child.props.children}</SwiperSlide>;
        }
        return child;
    });

    return <Swiper {...swiperProps}>{processedChildren}</Swiper>;
};

const DebateStudentDetail = ({ 
    debateInfo, 
    studentSubmission,
    indexs,
    handleClickAnswerDetail = () => null,
}) => {
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

    const [showStudentNames, setShowStudentNames] = useState(false);

    const swiperRef = useRef(null);
    const handleNext = () => {
        if (swiperRef.current) {
            swiperRef.current.slideNext();
        }
    };
    const handlePrev = () => {
        if (swiperRef.current) {
            swiperRef.current.slidePrev();
        }
    };

    return (
    <SentryWrap>
        <div className="ideaMdlUpr">
            <div className="debateBackBtn" onClick = {() => handleClickAnswerDetail()}>
                <img src={DebateLftIcon} alt="Debate" />
            </div>
            <Row>
                <Col xs={24}>
                    <div className="debateMdlTop debateAllTopTxt debateTopBckBtn debateAllTopSpace">
                        <img src={DebateNewLogo} alt="Debate" />
                        <div className="topSliderHeaderTxt">
                            <span className="breakTheSentence">{debateInfo?.question}</span>
                        </div>
                    </div>
                </Col>
                <Col xs={24}>
                    <div className="debateStdntDetailSection">
                        <SwiperCarousel
                            effect={"flip"}
                            grabCursor={true}
                            pagination={false}
                            navigation={false}
                            className="mySwiper"
                            onSwiper={(swiper) => {
                                swiperRef.current = swiper;
                            }}
                            initialSlide={indexs}
                            onSlideChange={(swiper) => {
                                setCurrentQuestionIndex(swiper.activeIndex);
                              }}
                        >
                            {studentSubmission.map((item, index) => {
                                return(
                            <div key={index} data-swiper-slide>
                                <div className="allStudentDetails debateStdntSectionResult">
                                    <div>
                                    <span style={{textAlign: 'left'}} dangerouslySetInnerHTML={{ __html: item?.answer_text || '' }} />
                                    </div>
                                    {showStudentNames ? (
                                    <p>{item?.user_name}</p>
                                    ): (
                                        <p>{`Estudiante ${index + 1}`}</p>
                                    )}
                                </div>
                            </div>
                                )
                            })}
                        </SwiperCarousel>
                    </div>

                    <div className="debateCardNavUpr">
                        <div className="debatStdntDetail">
                            <span>Show student names</span>
                            <Switch 
                                onClick={(checked) => setShowStudentNames(checked)}
                            />
                        </div>
                        <div className="debateCardNav">
                            <button
                                className={`debateNavbtn debateNavPre ${currentQuestionIndex === 0  ? 'btnDisabled' : ''}`}
                                onClick={handlePrev}
                                disabled={currentQuestionIndex === 0}
                            >
                                <img src={DebateLftIcon} alt="Debate" />
                            </button>
                            <button
                                className={`debateNavbtn debateNavNxt ${currentQuestionIndex === studentSubmission?.length - 1 ? 'btnDisabled' : ''}`}
                                onClick={handleNext}
                                disabled={currentQuestionIndex === studentSubmission?.length - 1}
                            >
                                <img src={DebateRgtIcon} alt="Debate" />
                            </button>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    </SentryWrap>
    );
};


export default DebateStudentDetail;